module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-00.94806549.png";